/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

export type FormUmbBlockElementModelContentType =
	(typeof FormUmbBlockElementModelContentType)[keyof typeof FormUmbBlockElementModelContentType];

export const FormUmbBlockElementModelContentType = {
	formUmbBlock: "formUmbBlock",
} as const;
